import ProjectListing from "../../views/Project/ProjectListing";

const ProjectPage = () => {
  return <ProjectListing />;
};

export default ProjectPage;
